module.exports = __webpack_public_path__ + "fonts/nunito-v12-latin-ext_cyrillic-ext_cyrillic_vietnamese_latin-italic.c8caa955.woff2";